import Icon from 'veui/components/Icon'
import { IconChevronLeft } from 'dls-icons-vue'

Icon.register('chevron-left', IconChevronLeft)
